export const colors = {
  bg: '#010c19',
  nav: 'rgb(6, 5, 35, 0.9)',
  navSolid: '#060523',
  text: '#d8e0f3',
  muted: '#808dcb',
  green: '#34a92c',
  greenSoft: 'rgba(39, 170, 68, 0.2)',
  greenSelected: 'rgba(39, 170, 68, 0.4)',
  greenMuted: '#6a9a66',
  greenMutedSoft: 'rgba(106, 154, 102, 0.2)',
  purple: '#9563bb',
  purpleSoft: 'rgba(149, 99, 187, 0.12)',
  purpleMuted: '#7a6a8f',
  purpleMutedSoft: 'rgba(122, 106, 143, 0.18)',
  amber: '#e6a23c',
  amberSoft: 'rgba(230, 162, 60, 0.2)',
  blue: '#4c8bf5',
  blueSoft: 'rgba(76, 139, 245, 0.18)',
  red: '#e05555',
  redSoft: 'rgba(224, 85, 85, 0.18)',
  cardBg: 'rgba(0, 0, 0, 0.4)',
};
